import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Tab,
  Tabs,
  IconButton,
  Paper,
  Hidden,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
  makeStyles,
  Button,
  Tooltip,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { RECLAMOS_ESTADOS, RECLAMOS_MENU_INFORMACION } from "../../../../utils/constants";
import { AfiliadoMenu } from "./AfiliadoMenu";
import { DerivacionesReclamosMenu } from "./DerivacionesReclamosMenu";
import { DocumentacionReclamosMenu } from "./DocumentacionReclamosMenu";
import { InformacionReclamoMenu } from "./InformacionReclamoMenu";
import { ModalEfectorReclamos } from "./ModalEfectorReclamos";
import IconEstado from "../../../autorizaciones/UI/IconEstado";
import { NoEncryption, NotificationsActiveSharp, Print } from "@material-ui/icons";
import { ModalImpresionReclamo } from "./ModalImpresionReclamo";
import { getReclamosTomadosPorUsuario, putLiberarReclamo, TraerReclamoPorIdAfiliado } from "../../../../actions/reclamos/reclamosActions";
import { useEffect } from "react";
import Poppers from "@material-ui/core/Popper";
import classNames from "classnames";
import { styles } from "@material-ui/pickers/views/Calendar/Calendar";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(styles);

export const ModalComentariosReclamos = (props, { type = 'currentUser' }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { solicitudSeleccionada = {}, dataAfiliado, reclamos = {}, reclamosTomadosUsuario = {} } = useSelector((state) => state.reclamos);
  const [selectedTab, setSelectedTab] = useState(
    RECLAMOS_MENU_INFORMACION.AFILIADO
  );
  const { fechaFin, fechaInicio } = props;
  const [openModalImpresion, setOpenModalImpresion] = useState(false);
  const [reclamosPendientes, setReclamosPendientes] = useState([]);
  const [openNotification, setOpenNotification] = useState(null);
  const [reclamoTomado, setReclamoTomado] = useState([]);
  const { idUsuario } = useSelector((state) => state.auth);


  const disabled = props.disabled;

  const mostrarNot = reclamosPendientes.length > 0 ? true : false;

  useEffect(() => {
    dispatch(TraerReclamoPorIdAfiliado(solicitudSeleccionada?.idAfiliado));
    dispatch(getReclamosTomadosPorUsuario());
  }, [dispatch])

  useEffect(() => {
    if (Array.isArray(reclamos) && reclamos.length > 0) {
      setReclamosPendientes(
        reclamos.filter((item) => item.estado === parseInt(RECLAMOS_ESTADOS.PENDIENTE) && item.id !== solicitudSeleccionada?.id)
      );
    }
  }, [reclamos]);

  const handleClickNotification = event => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);

    } else {
      setOpenNotification(event.currentTarget);
    }
  };

  const handleCloseNotification = () => {
    setOpenNotification(null);
  };

  useEffect(() => {

    if (
      Array.isArray(reclamosTomadosUsuario) &&
      reclamosTomadosUsuario.length > 0 &&
      idUsuario &&
      solicitudSeleccionada
    ) {
      const resultado = reclamosTomadosUsuario.filter(
        (item) =>
          item.idUsuarioTomada === idUsuario &&
          item.fechaLiberada === null &&
          item.idReclamo === solicitudSeleccionada.id
      );
      setReclamoTomado(resultado); // Actualiza el estado
    }
  }, [reclamosTomadosUsuario, solicitudSeleccionada]);


  return (
    <>
      {openModalImpresion && (
        <ModalImpresionReclamo
          disabled={disabled}
          open={openModalImpresion}
          closeModalHandler={() => {
            setOpenModalImpresion(false);
          }}
          solicitud={solicitudSeleccionada}
        />
      )}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={props.open}
        onClose={props.closeModalHandler}
      >
        <DialogTitle>
          <IconButton
            style={{ float: 'right', padding: 0, marginLeft: 15 }}
            color="inherit"
            onClick={() => {
              setOpenModalImpresion(true);
            }}
          >
            <Print />
          </IconButton>
          {reclamoTomado[0]?.id > 0 &&
            <Tooltip
              title={
                <>
                  <span sx={{
                    fontSize: 16,
                  }}>
                    {`Liberar Solicitud`}
                  </span>
                </>
              }
            >
              <IconButton
                style={{ float: 'right', padding: 0 }}
                color="inherit"
                onClick={() => {
                  dispatch(putLiberarReclamo(reclamoTomado[0]?.id, type, solicitudSeleccionada?.id));
                  props.closeModalHandler();
                }}
              >
                <NoEncryption />
              </IconButton>
            </Tooltip>
          }
          {mostrarNot && reclamosPendientes?.length > 0 && (
            <div className={classes.manager}>
              <Button
                aria-owns={openNotification ? "notification-menu-list-grow" : null}
                aria-haspopup="true"
                onClick={handleClickNotification}
                className={classes.buttonLink}
              >
                <NotificationsActiveSharp className={classes.icons} />
                {mostrarNot && reclamosPendientes?.length > 0 && (
                  <span className={classes.notifications}>{reclamosPendientes?.length}</span>
                )}
                <Hidden mdUp implementation="css">
                  <p onClick={handleCloseNotification} className={classes.linkText}>
                    Notification
                  </p>
                </Hidden>
              </Button>
              {mostrarNot && reclamosPendientes?.length > 0 && (
                <Poppers
                  open={Boolean(openNotification)}
                  anchorEl={openNotification}
                  transition
                  disablePortal={false}
                  className={
                    classNames({ [classes.popperClose]: !openNotification }) +
                    " " +
                    classes.popperNav
                  }
                  style={{ zIndex: 1301 }}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      id="notification-menu-list-grow"
                      style={{
                        transformOrigin:
                          placement === "bottom" ? "center top" : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleCloseNotification}>
                          <MenuList role="menu">
                            {/* Mapear notificaciones */}
                            {reclamosPendientes.map((log) => (
                              <MenuItem
                                key={log.id}
                                className={classes.dropdownItem}
                              >
                                Id {log.id} -{log.descripcionSeccional} - Estado: {log.descripcionEstado} - Derivado: {log.derivado}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Poppers>
              )}
            </div>
          )}
          <span style={{ float: "left" }}>
            Resumen - ID Caso: {props.solicitud?.id}
          </span>

          {dataAfiliado?.fecha_baja !== null && (
            <>
              {/* Espacios en blanco */}
              <span style={{ color: "red", marginLeft: '10px' }}>(BENEFICIARIA/O DE BAJA)</span>
            </>
          )}

          <br />
          <div>
            <span style={{ marginRight: '10px' }}>
              Categoría: {solicitudSeleccionada?.descripcionCategoriaReclamo}
            </span>

          </div>
          {props.solicitud?.urgente === 1 ? (
            <div>
              Urgente:
              <span style={{ marginRight: '10px' }}></span>
              <IconEstado
                useColorTable={true}
                texto={solicitudSeleccionada?.letraUrgente}
                backgroundColor={solicitudSeleccionada?.colorUrgente}
                descripcion={solicitudSeleccionada?.descripcion}
              />
            </div>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Tabs
            value={selectedTab}
            onChange={(_event, newValue) => setSelectedTab(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              value={RECLAMOS_MENU_INFORMACION.AFILIADO}
              label="BENEFICIARIA/O"
              {...a11yProps(RECLAMOS_MENU_INFORMACION.AFILIADO)}
            />
            <Tab
              value={RECLAMOS_MENU_INFORMACION.EFECTOR}
              label="Efector"
              {...a11yProps(RECLAMOS_MENU_INFORMACION.EFECTOR)}
            />
            <Tab
              value={RECLAMOS_MENU_INFORMACION.INFORMACION}
              label="Información / Comentarios"
              {...a11yProps(RECLAMOS_MENU_INFORMACION.INFORMACION)}
            />
            <Tab
              value={RECLAMOS_MENU_INFORMACION.DOCUMENTACION}
              label="Documentación"
              {...a11yProps(RECLAMOS_MENU_INFORMACION.DOCUMENTACION)}
            />
            <Tab
              value={RECLAMOS_MENU_INFORMACION.DERIVACIONES}
              label="Administrar"
              {...a11yProps(RECLAMOS_MENU_INFORMACION.DERIVACIONES)}
            />
          </Tabs>
          <TabPanel
            value={selectedTab}
            index={RECLAMOS_MENU_INFORMACION.AFILIADO}
          >
            <AfiliadoMenu afiliado={solicitudSeleccionada?.idAfiliado} solicitud={solicitudSeleccionada} />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={RECLAMOS_MENU_INFORMACION.EFECTOR}
          >
            <ModalEfectorReclamos
              solicitud={solicitudSeleccionada}
              disabled={disabled}
              onCloseModalAuditar={props.closeModalHandler}
              fechaFin={fechaFin}
              fechaInicio={fechaInicio}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={RECLAMOS_MENU_INFORMACION.INFORMACION}
          >
            <InformacionReclamoMenu
              solicitud={solicitudSeleccionada}
              onCloseModalAuditar={props.closeModalHandler}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={RECLAMOS_MENU_INFORMACION.DOCUMENTACION}
          >
            <DocumentacionReclamosMenu
              onCloseModalAuditar={props.closeModalHandler}
              solicitud={solicitudSeleccionada}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={RECLAMOS_MENU_INFORMACION.DERIVACIONES}
          >
            <DerivacionesReclamosMenu
              disabled={disabled}
              onCloseModalAuditar={props.closeModalHandler}
              fechaFin={fechaFin}
              fechaInicio={fechaInicio}
              reclamoTomado={reclamoTomado}
            />
          </TabPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};
